import { LoginOutlined } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React, {useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../../../redux/store";
import * as userReducer from "../../../../redux/users/users.reducers";
import { secondary } from "../../../../themes/theme";
import { RevealFade } from "../../../../utils/Reveal";
import { TokenUtil } from "../../../../utils/TokenUtil";
import ExploreButton from "../../../../utils/common/explore-button/ExploreButton";
import SplashScreen from "./SplashScreen";

const HomePage: React.FC = () => {
  const [showSplash, setShowSplash] = useState(true);
  const navigate = useNavigate();

  //Get data from redux store
  const userState: userReducer.InitialState = useSelector(
    (state: RootState) => {
      return state[userReducer.userFeatureKey];
    }
  );

  const { isAuthenticated } = userState;

  const handleSplashComplete = () => {
    setShowSplash(false);
  };

  useEffect(() => {
    const handleBackButton = (e: any) => {
      e.preventDefault();
      if (
        (window.location.pathname === "/users/login" ||
        window.location.pathname === "/") && !isAuthenticated
      ) {
        navigate("/users/login");
      }
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [navigate]);

  return (
    <>
      <Box className="landing-page">
        <Box className="wrapper">
          <Box
            component="div"
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              height: "100vh",
            }}
          >
            {showSplash && showSplash ? (
              <>
                <SplashScreen onComplete={handleSplashComplete} />
              </>
            ) : (
              <>
                <RevealFade>
                  <Typography
                    paragraph
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      fontWeight: "bold",
                      color: secondary[50],
                      letterSpacing: "5px",
                      fontFamily: "Poppins",
                      fontSize: {
                        xs: "55px",
                        sm: "75px",
                        md: "80px",
                        lg: "100px",
                        xl: "110px",
                      },
                    }}
                  >
                    hum
                  </Typography>
                </RevealFade>
                <RevealFade>
                  <Box component="div">
                    {TokenUtil.isLoggedIn() && isAuthenticated ? (
                      <ExploreButton
                        buttonText="Explore"
                        onClick={() => navigate("/products/fashion")}
                      />
                    ) : (
                      <ExploreButton
                        buttonText="Login"
                        buttonIcon={<LoginOutlined />}
                        onClick={() => navigate("/users/login")}
                      />
                    )}
                  </Box>
                </RevealFade>
              </>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default HomePage;
